// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpMmqls___s5cw4jGliU{display:flex;flex-direction:column;padding-bottom:20px;gap:10px;width:80vw;min-height:200px;max-height:550px;height:80vh;min-width:300px;max-width:1000px}.UpMmqls___s5cw4jGliU .hyltNNWbGIM1X34yC1gp{width:100%;height:100%;display:flex;flex-direction:row;gap:1em}.UpMmqls___s5cw4jGliU .hyltNNWbGIM1X34yC1gp .jJScqIbXn05OeXbI3m5C{flex:1 1 50%}.UpMmqls___s5cw4jGliU .hyltNNWbGIM1X34yC1gp .tuNZ64gBT7vb4GFPV24c{flex:1 1 50%;display:flex;flex-direction:column;align-items:center}.UpMmqls___s5cw4jGliU .hyltNNWbGIM1X34yC1gp .tuNZ64gBT7vb4GFPV24c .zu79GRvwz4P7OsdJO9DM{margin:auto;height:100%;display:flex;justify-content:center;flex-direction:column;align-items:center}.UpMmqls___s5cw4jGliU .hyltNNWbGIM1X34yC1gp .wVJu8JWc6hQzq3KuPNRg{width:100%;height:100%;flex:1}.UpMmqls___s5cw4jGliU .rRpHl2ulsLENXmcaPKD3{width:100%;height:100%;display:flex;flex-direction:row;gap:1em}.UpMmqls___s5cw4jGliU .rRpHl2ulsLENXmcaPKD3 .jJScqIbXn05OeXbI3m5C{flex:1 1 30%;padding-right:1em;border-right:1px solid var(--color-sa-lightgray)}.UpMmqls___s5cw4jGliU .rRpHl2ulsLENXmcaPKD3 .tuNZ64gBT7vb4GFPV24c{flex:1 1 70%}.UpMmqls___s5cw4jGliU .rRpHl2ulsLENXmcaPKD3 .tuNZ64gBT7vb4GFPV24c h3{color:#6e32f0;text-align:center;font-size:15px;font-weight:600;margin-bottom:2rem;letter-spacing:.6rem;text-transform:uppercase}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `#ff6040`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `#99a8c6`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `#b8baca`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `#fbab00`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `#2eb6ea`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `#3aaa35`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `#ff4141`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"root": `UpMmqls___s5cw4jGliU`,
	"twoColumns": `hyltNNWbGIM1X34yC1gp`,
	"leftColumn": `jJScqIbXn05OeXbI3m5C`,
	"rightColumn": `tuNZ64gBT7vb4GFPV24c`,
	"carouselItem": `zu79GRvwz4P7OsdJO9DM`,
	"image": `wVJu8JWc6hQzq3KuPNRg`,
	"twoColumns30": `rRpHl2ulsLENXmcaPKD3`
};
export default ___CSS_LOADER_EXPORT___;
